<template>
    <div class="horizontal-align-ab">
        <span class="icon-loading1"></span> {{ loadingMsg }}
    </div>
</template>

<script>
/* global Helpers */

export default {
    name: 'login',
    data () {
        return {
            user: null,
            token: null,
            destination: '/templates',
            loadingMsg: 'Loading...',
            template: null
        }
    },
    beforeMount () {
        this.$store.commit('user', this.$route.query.user)
        this.$store.commit('token', this.$route.query.token)

        this.user = this.$route.query.user
        this.token = this.$route.query.token

        if (this.$route.query.show !== undefined) {
            this.$store.commit('show', this.$route.query.show)
        }

        if (this.$route.query.cat !== undefined) {
            this.$store.commit('cat', this.$route.query.cat)
        }

        if (this.$route.query.mode !== undefined) {
            this.$store.commit('mode', this.$route.query.mode)

            // Editor Mode - Check for template & fetch
            this.template = this.$route.query.template

            if (this.$route.query.mode === 'editor') {
                if (this.template === undefined || this.template === null) {
                    this.loadingMsg = 'Sorry, we can\'t load the template you\'ve selected'
                }
            }
        }

        if (this.user && this.token) {
            this.$auth.login({
                params: {
                    user: this.user,
                    token: this.token
                },
                success: function (res) {
                    if (this.template !== null) {
                        this.axios.get('/templates/' + this.template + '?include=userversions,vendors')
                        .then(
                            response => {
                                this.$store.commit('template', response.data.data)
                                this.$router.push({ name: 'Template Designer' })
                            }
                        ).catch(function (error) {
                            Helpers.errorPop('Error', error)
                        })
                    }
                },
                error: function (error) {
                    // let errorreturn = error.response.data
                    let errorlist = []
                    // if (typeof errorreturn.message !== 'string') {
                    //     for (let i = 0; i < Object.keys(errorreturn).length; i++) {
                    //         errorlist.push(errorreturn[Object.keys(errorreturn)[i]][0])
                    //     }
                    // } else {
                    errorlist.push(error.response.data.message)
                    // }
                    // Return Errors
                    this.form.goterrors = errorlist
                    // Clear Form
                    this.form.email = ''
                    this.form.password = ''
                },
                rememberMe: true,
                redirect: this.destination,
                fetchUser: true
            })
        }
    },
    mounted () {
    }
}
</script>
    <div class="horizontal-align-ab">
        <span class="icon-loading1"></span> {{ loadingMsg }}
    </div>

<style lang="scss" scoped>
    @-webkit-keyframes spin {
        0%  {-webkit-transform: rotate(0deg);}
        100% {-webkit-transform: rotate(360deg);}
    }

    div.horizontal-align-ab {
        font-size: 1.3em;
        padding-left: 1.7em;
        padding-top: 25%;
        padding-bottom: 75%;
        color: #000000;

        span {
            left: 0;
            color: #bbbbbb;
            font-size: 1.2em;
            padding: .1em;
            position: absolute;
            -webkit-animation: spin .7s infinite linear;
        }
    }
</style>



// WEBPACK FOOTER //
// Login.vue?8a0ef5d4